<!-- eslint-disable max-len -->
<template>
  <Dialog
    v-model:visible="state$$.infoIdentificationNumber.isVisible"
    class="info-identification-number-dialog"
    :dismissable-mask="false"
    :modal="false"
    style="max-width: 700px"
    :breakpoints="{ '960px': '75vw', '641px': '100vw' }"
  >
    <template #header>
      Información de DNI / NIE
    </template>

    <div class="info-identification-number-dialog__body">
      <p>Si el DNI tiene fecha de validez permanente indicar 01/01/9999.</p>
    </div>

    <template #footer>
    </template>
  </Dialog>
</template>

<script setup>
// #region VUE
import {inject, onBeforeUnmount} from 'vue';
// #endregion

// #region Components
import Dialog from 'primevue/dialog/sfc';
// #endregion

// #region Params, Ref, Reactives, Computed
const state$$ = inject('registerState$$');
// #endregion

// #region Effects, Hooks
onBeforeUnmount(() => {
  const field = document.querySelector('.form__item--validdatedni input');
  if (!field) return;
  field.focus();
});
// #endregion
</script>

<style lang="scss" scoped>
@use "@/styles/vars" as *;
@use "@/styles/breakpoints" as *;
.info-identification-number-dialog {
  &__body {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: $brand__boxspace--medium;
    &__images {
      display: flex;
      flex-direction: row;
      gap: $brand__boxspace--medium;
    }
  }
}
</style>
